import { render, staticRenderFns } from "./FriendTypePage.vue?vue&type=template&id=7b772fe4&"
import script from "./FriendTypePage.vue?vue&type=script&lang=js&"
export * from "./FriendTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports